import { render, staticRenderFns } from "./snowprinces.vue?vue&type=template&id=92591d70&scoped=true"
import script from "./snowprinces.vue?vue&type=script&lang=js"
export * from "./snowprinces.vue?vue&type=script&lang=js"
import style0 from "./snowprinces.vue?vue&type=style&index=0&id=92591d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92591d70",
  null
  
)

export default component.exports